export default __webpack_public_path__ + "static/elTorito-34b0654abcc913f179cee0fc96baca71.svg";